
<template>
  <div class="details_form_item">
    <Form ref="editModel" :model="editModel" :label-width="150">
      <FormItem label="医院编码：">{{ editModel.organCode }}</FormItem>
      <FormItem label="患者编号：">{{ editModel.parentID }}</FormItem>
      <FormItem label="患者姓名：">{{ editModel.patientName }}</FormItem>
      <FormItem label="患者性别：">{{ editModel.patientSex=='M'?'男':editModel.patientSex=='F'?'女':'' }}</FormItem>
      <FormItem label="患者年龄：">{{ editModel.patientAge }}</FormItem>
      <FormItem label="出生日期：">{{editModel.patientBirthday}}</FormItem>
      <FormItem label="检查描述：">{{editModel.studyDescription}}</FormItem>
      <FormItem label="检查主键：">{{ editModel.studyID }}</FormItem>
      <FormItem label="STUDYUID：">{{editModel.studyInstanceUID}}</FormItem>
      <FormItem label="影像类型：">{{ editModel.imgFileType==0||editModel.imgFileType==1?'DICOM':'非DICOM' }}</FormItem>
      <FormItem label="影像数量：">{{ editModel.imageCount }}</FormItem>
      <FormItem label="是否回写ris：">{{ editModel.risImageCountFlag==0?'未回写/无需回写':editModel.risImageCountFlag==1?'已回写':'回写失败' }}</FormItem>
      <FormItem label="是否手动匹配匹配：">{{ editModel.handmatch==0?'未匹配/无需匹配':editModel.handmatch==1?'已匹配':'匹配失败' }}</FormItem>
      <FormItem label="最后更新时间：">{{editModel.lastUpdateDate}}</FormItem>
      <FormItem label="检查类型：">{{ editModel.studyModality }}</FormItem>
      <FormItem label="OOS存储状态：">{{ editModel.oosUploadFlag==null?'未压缩':oosState[editModel.oosUploadFlag] }}</FormItem>
      
      <FormItem label="设备厂商：">{{ editModel.deviceManufacture }}</FormItem>
      <FormItem label="检查编号：">{{editModel.accessionNumber}}</FormItem>
      <FormItem label="检查部位名称：">{{ editModel.examBodyName }}</FormItem>
      <FormItem label="检查日期：">{{ editModel.examDate }}</FormItem>
      <FormItem label="检查项目名称：">{{ editModel.examItemName }}</FormItem>
      <FormItem label="检查时间：">{{ editModel.examTime }}</FormItem>
      <FormItem label="存储路径：">{{ editModel.pathDetail }}</FormItem>
      <FormItem label=" RIS标记：">{{ editModel.rISFlag }}</FormItem>
      <FormItem label="序列数量：">{{ editModel.serieseCount }}</FormItem>
      <FormItem label="层厚：">{{ editModel.slicethickness }}</FormItem>
      <FormItem label="工作站名：">{{ editModel.stationname }}</FormItem>
      <FormItem label="窗位：">{{ editModel.winCenter }}</FormItem>
      <FormItem label="窗宽：">{{ editModel.winWide }}</FormItem>
    </Form>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
import {oosState} from '@/utils'
export default {
  props: ["currentData"],
  data: function () {
    return {
      editModel: {},
      oosState
    };
  },

  created () {
    this.editModel = this.currentData;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
</style>